import React from 'react';
import { SafeAreaProvider } from 'react-native-safe-area-context';

import { createNativeStackNavigator } from '@react-navigation/native-stack';

import { PhoneVerificationScreen } from '@/feature/verify-phone-number/screens/PhoneVerification';
import { screenPresets } from '@/navigation/screen-presets';
import { AccountEditStackParamList } from '@/navigation/types';
import { common } from '@/styles/styles';

import { EmailUpdate } from './screens/EmailUpdate';
import { EmailUpdateConfirm } from './screens/EmailUpdateConfirm';
import { ManageDebitCardExpiryUpdate } from './screens/ManageDebitCardExpiryUpdate';
import { PasswordEdit } from './screens/PasswordEdit';
import { PhoneNumberEdit } from './screens/PhoneNumberEdit';
import { PhoneNumberEditInitialVerification } from './screens/PhoneNumberEditInitialVerification';
import { PhoneNumberEditUpdatedVerification } from './screens/PhoneNumberEditUpdatedVerification';

const Stack = createNativeStackNavigator<AccountEditStackParamList>();

/** Multi-step account actions opened as one sheet over Account; grouped so they share a single PhoneVerification */
export const AccountEditStack = () => (
    <SafeAreaProvider style={common.flex}>
        <Stack.Navigator screenOptions={screenPresets.modalStack}>
            <Stack.Screen name="PhoneVerification" component={PhoneVerificationScreen} />
            <Stack.Screen name="PasswordEdit" component={PasswordEdit} />
            <Stack.Screen name="EmailUpdate" component={EmailUpdate} />
            <Stack.Screen name="EmailUpdateConfirm" component={EmailUpdateConfirm} />
            <Stack.Screen name="PhoneNumberEditInitialVerification" component={PhoneNumberEditInitialVerification} />
            <Stack.Screen name="PhoneNumberEdit" component={PhoneNumberEdit} />
            <Stack.Screen name="PhoneNumberEditUpdatedVerification" component={PhoneNumberEditUpdatedVerification} />
            <Stack.Screen name="ManageDebitCardExpiryUpdate" component={ManageDebitCardExpiryUpdate} />
        </Stack.Navigator>
    </SafeAreaProvider>
);
